import React, { ChangeEvent, useState } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Unstable_Grid2';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import _ from 'lodash';

interface ConfirmationDialogProps {
  open: boolean;
  title?: string;
  message: string | JSX.Element;
  confirmationTextLabel?: string;
  confirmationText?: string;
  confirmationTextCaseSensitive?: boolean;
  okLabel?: string;
  cancelLabel?: string;
  onClose: (agreed: boolean) => void;
}

function ConfirmationDialog(props: ConfirmationDialogProps) {
  const [confirmationTyped, setConfirmationTyped] = useState('');

  function handleConfirmationTextChange(event: ChangeEvent<HTMLInputElement>) {
    setConfirmationTyped(event.target.value);
  }

  function canProceed() {
    if (_.isEmpty(props.confirmationText)) {
      return true;
    }

    if (props.confirmationTextCaseSensitive) {
      return confirmationTyped === props.confirmationText;
    } else {
      return (
        confirmationTyped?.toLowerCase() ===
        props.confirmationText.toLowerCase()
      );
    }
  }

  return (
    <Dialog
      open={props.open}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      data-testid="confirmationDialog"
    >
      <DialogTitle id="confirmation-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description" component="div">
          {props.message}
        </DialogContentText>
        {props.confirmationText && (
          <Grid container alignItems="center" spacing={1}>
            <Grid>
              <Typography variant="body2">
                {props.confirmationTextLabel}
              </Typography>
            </Grid>
            <Grid>
              <TextField
                variant="outlined"
                size="small"
                autoFocus
                onChange={handleConfirmationTextChange}
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => props.onClose(false)} color="primary">
          {props.cancelLabel || 'Cancel'}
        </Button>
        <Button
          color="primary"
          autoFocus
          disabled={!canProceed()}
          onClick={(e) => props.onClose(true)}
        >
          {props.okLabel || 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
